import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../utl/models/Visiable";
import { GroupsState } from "../models/GroupsState";

const setSearchClientsFormVisiable = (state: GroupsState, action: PayloadAction<Visiable>) => {
    const { visiable } = action.payload;
    state.searchClientsFormVisiable = visiable;
}

export default setSearchClientsFormVisiable;